@if (tableSource.filteredData.length) {
  <div class="info-container">
    <mat-table
      #table
      [dataSource]="tableSource"
    [ngClass]="{
      'legal-notes': isLegalNote,
      'complete-conditions': isCompleteConditions
    }"
      >
      <ng-container matColumnDef="cleared">
        <mat-header-cell *matHeaderCellDef>Cleared</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mat-checkbox
            [ngModel]="item.cleared"
            (ngModelChange)="updateCleared($event, projectId, item)"
          [disabled]="
            !(item.extendedPermissions || item.permissions) ||
            !item.name?.length ||
            !!item.saving || item.resolution == null || readOnly
          "
          ></mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="issue">
        <mat-header-cell *matHeaderCellDef>{{
          !!isLegalNote ? "Note" : "Disclosure"
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <span
            class="issue-wrapper"
            [ngClass]="item.name?.length ? '' : 'empty'"
            >
            <div class="text-grid" #textGrid [attr.data-extra-text]="item.name">
              <textarea
                rows="1"
                placeholder="{{ !!isLegalNote ? 'Notes...' : 'Disclosure...' }}"
              [disabled]="
                !(item.extendedPermissions || item.permissions) || !!item.saving || readOnly
              "
                [ngModel]="item.name"
              (ngModelChange)="
                item.name = $event;
                textGrid.setAttribute('data-extra-text', $event)
              "
                >
              </textarea>
            </div>
            <button
              type="button"
              [disabled]="!item.name?.length && !item.saving || readOnly"
              (click)="isClosingItem ? saveIssue(projectId,item, milestoneContext) : saveIssue(projectId,item)"
              >
              @if (
                (item.extendedPermissions || item.permissions) && !readOnly
                ) {
                <mat-icon
                  >{{ item.name?.length ? "save" : "warning" }}</mat-icon
                  >
                }
              </button>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="solution">
          <mat-header-cell *matHeaderCellDef>Resolution</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <span class="issue-wrapper">
              <div
                class="text-grid"
                #textGrid2
                [attr.data-extra-text]="item.resolution"
                >
                <textarea
                  rows="1"
                  placeholder="Resolution..."
              [disabled]="
                !(item.extendedPermissions || item.permissions) || !!item.saving || readOnly
              "
                  [ngModel]="item.resolution"
              (ngModelChange)="
                item.resolution = $event;
                textGrid2.setAttribute('data-extra-text', $event)
              "
                  >
                </textarea>
              </div>
              <button
                type="button"
            [disabled]="
              (!item.name?.length && !item.resolution?.length && !item.saving ) || readOnly
            "
                (click)="isClosingItem ? service.saveCommitteeItem(projectId, item, undefined, milestoneContext) : service.saveCommitteeItem(projectId, item)"
                >
                @if (
                  (item.extendedPermissions || item.permissions) && !readOnly
                  ) {
                  <mat-icon
                    >save</mat-icon
                    >
                  }
                </button>
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="post_closing">
            <mat-header-cell *matHeaderCellDef>Post-Closing</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                [ngModel]="item.is_post_closing"
                (ngModelChange)="updatePostClosing($event, projectId, item)"
          [disabled]="
            !(item.extendedPermissions || item.permissions) ||
            !item.name?.length ||
            !!item.saving || readOnly
          "
              ></mat-checkbox>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="department">
            <mat-header-cell *matHeaderCellDef>Department</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <select
                class="milestone-list"
                [ngModel]="item.committee_approval_type_id"
                (ngModelChange)="handleDepartmentChange($event, item)"
          [disabled]="
            !(item.extendedPermissions || item.permissions) ||
            !item.name?.length ||
            !!item.saving || readOnly
          "
                >
                <option value="null">&mdash;</option>
                @for (approval of service.approvalTypes; track approval) {
                  <option
                    [value]="approval.id"
                    >
                    {{ approval.name }}
                  </option>
                }
              </select>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="related_department">
            <mat-header-cell *matHeaderCellDef>Department</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-select multiple class="milestone-list"
                          [panelWidth]="null"
                          placeholder="&mdash;"
                          [(ngModel)]="item.relatedApprovalTypes"
                          [compareWith]="compareApprovalById"
                          (openedChange)="onOpenChange($event, item)"
                          (selectionChange)="handleRelatedChange($event, item)"
                          [disabled]="!item.permissions || !item.name?.length || !!item.saving || readOnly"
              >
                @for(approval of approvalTypes; track $index){
                  <mat-option [value]="approval">{{approval.name}}</mat-option>
                }
              </mat-select>
<!--              <select-->
<!--                class="milestone-list"-->
<!--                [ngModel]="item.related_approval_type_id"-->
<!--                (ngModelChange)="handleRelatedChange($event, item)"-->
<!--          [disabled]="-->
<!--            !item.permissions ||-->
<!--            !item.name?.length ||-->
<!--            !!item.saving || readOnly-->
<!--          "-->
<!--                >-->
<!--                <option value="null">&mdash;</option>-->
<!--                @for (approval of service.approvalTypes; track approval) {-->
<!--                  <option-->
<!--                    [value]="approval.id"-->
<!--                    >-->
<!--                    {{ approval.name }}-->
<!--                  </option>-->
<!--                }-->
<!--              </select>-->
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="milestone">
            <mat-header-cell *matHeaderCellDef>Committee</mat-header-cell>
            <mat-cell *matCellDef="let item">
              @if (milestone?.name?.toLowerCase()!=='closed') {
                <select
                  class="approval-type-list"
                  [ngModel]="item.milestone_id"
                  (ngModelChange)="handleMilestoneChange($event, item)"
          [disabled]="
            !(item.extendedPermissions || item.permissions) ||
            !item.name?.length ||
            !!item.saving || readOnly
          "
                  >
                  <option value="null">&mdash;</option>
                  @for (milestone of milestones; track milestone) {
                    <option [value]="milestone.id">
                      {{ milestone.name }}
                    </option>
                  }
                </select>
              }
              @if (milestone?.name?.toLowerCase()=='closed') {
                <select
                  class="approval-type-list"
                  [ngModel]="milestone.id"
                  (ngModelChange)="handleMilestoneChange($event, item)"
          [disabled]="
            !(item.extendedPermissions || item.permissions) ||
            !item.name?.length ||
            !!item.saving || readOnly
          "
                  >
                  <option value="null">&mdash;</option>
                  @for (milestone of milestones; track milestone) {
                    <option [value]="milestone.id">
                      {{ milestone.name }}
                    </option>
                  }
                </select>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="added_by">
            <mat-header-cell *matHeaderCellDef>Added By</mat-header-cell>
            <mat-cell *matCellDef="let item">
              @if (item.creator?.person?.name) {
                {{ item.creator?.person?.name }}
              } @else {
                &mdash;
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="added_on">
            <mat-header-cell *matHeaderCellDef>Added On</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
          *ngTemplateOutlet="
            date;
            context: { date: getFormattedDate(item.created) }
          "
              ></span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="updated_by">
            <mat-header-cell *matHeaderCellDef>Updated By</mat-header-cell>
            <mat-cell *matCellDef="let item">
              @if (item.updater?.person?.name) {
                {{ item.updater?.person?.name }}
              } @else {
                &mdash;
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="updated_on">
            <mat-header-cell *matHeaderCellDef>Updated On</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
          *ngTemplateOutlet="
            date;
            context: { date: getFormattedDate(item.modified), item: item }
          "
              ></span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let item">
              @if (
                !isConditions &&
                !isClosingItem &&
                !isCompleteConditions &&
                legalPermissions &&
                item.name?.length && !readOnly
                ) {
                <button
                  type="button"
                  (click)="service.copyItemToConditions(projectId, item)"
                  >
                  <mat-icon>bookmark_outline</mat-icon>
                </button>
              }
              @if (
                !isClosingItem &&
                isConditions &&
                (item.extendedPermissions || item.permissions) && !readOnly
                ) {
                <button
                  type="button"
                  (click)="service.removeFromConditions(projectId, item)"
                  >
                  <mat-icon>bookmark_remove_outline</mat-icon>
                </button>
              }
              @if (
                !isConditions &&
                !isCompleteConditions &&
                (item.permissions) && !readOnly
                ) {
                <button
                  type="button"
                  (click)="service.deleteCommitteeItem(projectId, item)"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="headerColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: headerColumns"></mat-row>
        </mat-table>
        <ng-template #date let-date="date" let-item="item">
          @if (
            date && date.length && (!item || item.created !== item.modified)) {
            {{ date }}
          } @else {
            &mdash;
          }
        </ng-template>
      </div>
    }
